import { useCallback, useEffect, useState } from "react";
import { Icon, WifIcon } from "@business-finland/wif-ui-lib";
import Image from "next/image";

import styles from "./AinoChatButton.module.scss";
import { setLocalStoragePopupPrevented } from "./helpers";
import useChatPanelAutoOpen from "./useChatPanelAutoOpen";
import useChatPanelEvents from "./useChatPanelEvents";
import { useAinoChatPanel } from "./useAinoChatPanel";

export default function AinoChatButton(): JSX.Element | null {
  const chatPanel = useAinoChatPanel();
  const [isChatPanelOpen, setIsChatPanelOpen] = useState<boolean>(false);

  useChatPanelAutoOpen(chatPanel, setIsChatPanelOpen);
  useChatPanelEvents(chatPanel, setIsChatPanelOpen);

  useEffect(() => {
    if (isChatPanelOpen) chatPanel?.show();
    else chatPanel?.minimize();
  }, [isChatPanelOpen, chatPanel]);

  const handleClick = useCallback(() => {
    setLocalStoragePopupPrevented(false);
    setIsChatPanelOpen((value) => !value);
  }, []);

  if (!chatPanel) {
    return null;
  }

  return (
    <button
      id="ainoChatButton"
      role="button"
      className={styles["aino-chat-btn"]}
      aria-label="Aino"
      onClick={handleClick}
      data-open={isChatPanelOpen}
    >
      {isChatPanelOpen ? (
        <Icon icon={WifIcon.CLOSE} size={18} />
      ) : (
        <Image src="/static/images/icon_bot.jpg" alt="Aino" width="82" height="82" />
      )}
    </button>
  );
}
